import { render, staticRenderFns } from "./SkeltonSidebarBlogs.vue?vue&type=template&id=2c296c90&scoped=true&"
import script from "./SkeltonSidebarBlogs.vue?vue&type=script&lang=js&"
export * from "./SkeltonSidebarBlogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c296c90",
  null
  
)

export default component.exports